import type { Consent } from "./types.js";

/**
 * Client-side mirror of the backend consent gate (ingestion/consent-gate.ts). The pixel
 * pre-filters so we don't ship events the backend would only drop: in a GDPR-style region we
 * suppress the network call entirely unless `analytics` consent is present. The backend remains
 * the source of truth — this is a courtesy gate, kept byte-for-byte in step with the server regex.
 */
const GDPR_REGION = /^(EU|UK|GB|EEA|US-CA)/i;

/** Resolve the effective consent: an explicit per-call value wins over the config snapshot. */
export function resolveConsent(
  configConsent?: Consent,
  override?: Consent,
): Consent | undefined {
  return override ?? configConsent;
}

/**
 * Whether the pixel may send at all. Mirrors evaluateConsent().allowEvent for client events:
 * blocked only when in a GDPR region without analytics consent. Absent consent (no CMP) is
 * treated as non-GDPR and allowed, matching the server's region-gated policy.
 */
export function canTrack(consent?: Consent): boolean {
  const region = consent?.region ?? null;
  const gdpr = region != null && GDPR_REGION.test(region);
  if (gdpr && consent?.analytics !== true) return false;
  return true;
}
